import Column from '@amzn/meridian/column';
import { FooterMobile } from '@amzn/rangoli-seller-desktop-utils/src/index';
import { observer } from 'mobx-react-lite';
import React from 'react';

import { helpAndSupportStore } from '../../store/HelpAndSupportStore';
import { sidebarStore } from '../../store/SidebarStore';
import { profileMobileStyle } from '../../Style/Style';
import { IProfileMenuProps } from '../../types/MainHeaderTypes';
import ProfileMenu from './ProfileMenu';

const ProfileMenuMobile = ({ CategoriesList, isCategoryError, isLoading }: IProfileMenuProps) => {
  const { isProfileDetailsActive } = helpAndSupportStore;
  const { sidebarToggle } = sidebarStore;
  return (
    !sidebarToggle && (
      <Column
        width="100%"
        className={isProfileDetailsActive && profileMobileStyle}
        spacingInset="300"
        alignmentVertical="justify"
        spacing="none"
      >
        <ProfileMenu
          isLoading={isLoading}
          CategoriesList={CategoriesList}
          isCategoryError={isCategoryError}
        />
        {isProfileDetailsActive && <FooterMobile />}
      </Column>
    )
  );
};

export default observer(ProfileMenuMobile);
